import React, { ReactNode } from 'react'

import { DialogContent as MUIDialogContent } from '@mui/material'

interface DialogContentProps {
  children: ReactNode
  dividers?: boolean
  sx?: object
}

/**
 * [INSERT DESCRIPTION]
 */

const DialogContent = React.forwardRef(
  (props: DialogContentProps, ref: any) => {
    const { children, ...rest } = props

    return (
      <MUIDialogContent {...rest} ref={ref}>
        {children}
      </MUIDialogContent>
    )
  }
)

DialogContent.displayName = 'DialogContent'
export default DialogContent
